import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

import { EPayoutType } from '@/libs/types/global.types'

const initialState = { payoutId: '', type: EPayoutType.BANK }

const changeWithdrawalAccountSlice = createSlice({
  name: 'changeWithdrawalAccount',
  initialState,
  extraReducers(builder) {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    setPayout: (state, action: { payload: { id: string; type: EPayoutType } }) => {
      state.payoutId = action.payload.id
      state.type = action.payload.type
    },
    resetPayout: () => {
      return initialState
    },
  },
})

export const { setPayout, resetPayout } = changeWithdrawalAccountSlice.actions

export default changeWithdrawalAccountSlice.reducer
